import * as moment from "moment";
import {VisitScheduleDayModel} from "./visit-schedule-day.model";
import {VisitScheduleStatusEnum} from "../enums/visit-schedule-status.enum";

export function isVisitScheduleDayDispatched(day?: VisitScheduleDayModel): boolean {
  if (!day) return false;
  return day.status === VisitScheduleStatusEnum.Completed || !!day.totals?.dispatched || !!day.totals?.partialDispatched;
}

function findVisitScheduleDayById(days: VisitScheduleDayModel[], dayId: string): VisitScheduleDayModel {
  if (!dayId) return undefined;
  return days?.find(day => day.id === dayId);
}

export function findVisitScheduleDayByDate(days: VisitScheduleDayModel[], date: number): VisitScheduleDayModel {
  if (!date) return undefined;
  return days?.find(day => moment(day.date).isSame(date, 'day'));
}

export function isVisitScheduleDayDispatchedById(days: VisitScheduleDayModel[], dayId: string): boolean {
  return isVisitScheduleDayDispatched(findVisitScheduleDayById(days, dayId));
}

export function isVisitScheduleDayDispatchedByDate(days: VisitScheduleDayModel[], date: number): boolean {
  return isVisitScheduleDayDispatched(findVisitScheduleDayByDate(days, date));
}
